export class ProtectionPlanPricingPlan {
	protectionPlan: string;
	productServices: string;
	startDateOfTheProtectionPlan: string;
	endDateOfTheProtectionPlan: string;
	currency: string;
	billingMethod: string;
	invoicingMethod: string;
	paymentType: string;
	startDateOfThePricingPlan: string;
	endDateOfThePricingPlan: string;
	price: string;
	protectionBaseline: string;
	protectionLower: string;
	protectionMaximum: string;
}
